<dialog #dialog
        class="popin-dialog"
        aria-modal="true" aria-labelledby="popinTitle"
        (cancel)="onCancel($event)">
    <div class="modal-header d-flex justify-content-between flex-column flex-sm-row-reverse pb-2">
        <button type="button" class="btn p-1 align-self-end"
                (click)="close(false)">
            <span class="text-ocean btn-popin-close" translate="global.menu.close"></span>
            <ned-icon type="close" class="d-inline-block text-ocean"></ned-icon>
        </button>

        <h1 class="modal-title c-text-bold align-self-start align-self-sm-center" id="popinTitle">
            {{titre}}
        </h1>
    </div>

    <div class="modal-body px-4">
        <p class="h8 lh-sm text-center">{{ messagePopIn }}</p>
    </div>

    <div class="modal-footer justify-content-center p-4">
        <button (click)="close(false)"
                class="btn c-btn c-btn-ocean"
                #firstButton type="button">
            {{messageButton}}
        </button>
    </div>
</dialog>


